export default __webpack_public_path__ + "static/media/shopping-cart.c15509d5.svg";